{ combineReducers } = require 'redux'
ActionNames = require './ActionNames'

gamesById = (state = {}, action) ->
	switch action.type
		when ActionNames.GamesLoaded
			gamesById = {}
			gamesById[g.id] = g for g in action.games
			gamesById

		when ActionNames.GameAdded
			result = {}
			result[id] = g for id, g of state when id isnt action.game.id
			result[action.game.id] = action.game
			result

		when ActionNames.GameRemoved
			result = {}
			result[id] = g for id, g of state when id isnt action.gameId
			result

		when ActionNames.RoundAdded
			origGame = state[action.gameId]

			newGame = {}
			newGame[k] = v for k, v of origGame
			newGame.rounds = origGame.rounds.concat [{}]

			result = {}
			result[id] = g for id, g of state when id isnt action.gameId
			result[action.gameId] = newGame
			result

		when ActionNames.RoundUpdated
			origGame = state[action.gameId]
			origRound = origGame.rounds[action.roundNumber]

			newRounds = [].concat(origGame.rounds[0...action.roundNumber])
			newRounds.push action.round
			newRounds = newRounds.concat(origGame.rounds[action.roundNumber+1..])

			newGame = {}
			newGame[k] = v for k, v of origGame
			newGame.rounds = newRounds

			result = {}
			result[id] = g for id, g of state when id isnt action.gameId
			result[action.gameId] = newGame
			result

		when ActionNames.RoundRemoved
			origGame = state[action.gameId]

			newRounds = (round for round, i in origGame.rounds when i isnt action.roundNumber)

			newGame = {}
			newGame[k] = v for k, v of origGame
			newGame.rounds = newRounds

			result = {}
			result[id] = g for id, g of state when id isnt action.gameId
			result[action.gameId] = newGame
			result

		when ActionNames.GamesImported
			result = {}
			result[id] = g for id, g of state
			result[g.id] = g for g in action.games when not result[g.id]?
			result

		else
			state

module.exports = combineReducers {gamesById}